import { Vehicle } from "../../Interfaces/vehicle.type";
import getVehicleDataPush from "../getVehicleDataPush";

const openDeliveryModalDataPush = (vehicle: Vehicle) => {
  const vehicleDataPush = getVehicleDataPush(vehicle);

  //@ts-ignore
  if (window.digitalData) {
    //@ts-ignore
    return digitalData.push({
      event: {
        name: "click",
        category: "button",
        label: "delivery-options",
        action: "open",
        type: "card",
        value: "",
      },
      ...vehicleDataPush,
    });
  }
};

export default openDeliveryModalDataPush;
